module.exports = __webpack_public_path__ + "static/img/modal-icon.10ce7d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/ExperienceGold/modal-icon.png
// module id = UPFg
// module chunks = 216